import React from "react"
import types from "prop-types"
import { isEmpty, isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { getFilteredReports } from "reduxSlices/reportIndexSlice"
import { isFeatureEnabled } from "reduxSlices/featuresSlice"
import { TASK_REPORTS } from "utils/featuresHelpers"
import { TASK_REPORT_TYPE } from "utils/reportHelpers"
import { CustomHeaderAccordion, useAccordion } from "shared/accordions"
import GroupingAccordionHeader from "shared/headers/GroupingAccordionHeader"
import TaskReportList from "./TaskReportList"

const TaskReportsSection = ({ className = "" }) => {
  const [isExpanded, toggleAccordion] = useAccordion(true)
  const taskReportsEnabled = useSelector(isFeatureEnabled(TASK_REPORTS))
  const reports = useSelector(getFilteredReports(TASK_REPORT_TYPE), isEqual)

  if (!taskReportsEnabled || isEmpty(reports)) return null

  return (
    <section className={className}>
      <CustomHeaderAccordion
        isExpanded={isExpanded}
        header={(
          <GroupingAccordionHeader
            className="mb-4"
            groupName="Task Reports"
            isExpanded={isExpanded}
            toggleAccordion={toggleAccordion}
          />
        )}
        content={<TaskReportList />}
      />
    </section>
  )
}

TaskReportsSection.propTypes = {
  className: types.string,
}

export default TaskReportsSection
